import { Toaster } from "./components/ui/toaster"
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClientInstance } from './lib/query-client'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PageNotFound from './lib/PageNotFound';
import { AuthProvider, useAuth } from './lib/AuthContext';
import UserNotRegisteredError from './components/UserNotRegisteredError';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Pipeline from './pages/Pipeline';
import Calendar from './pages/Calendar';
import Calls from './pages/Calls';
import Messages from './pages/Messages';
import AIAgent from './pages/AIAgent';
import Settings from './pages/Settings';
import Team from './pages/Team';
import Register from './pages/Register';
import Login from './pages/Login';
import Prequalify from "./pages/Prequalify";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Onboarding from "./pages/Onboarding";
import OnboardingTest from "./pages/OnboardingTest";
import Profile from "./pages/Profile";
import Profiletest from "./pages/Profiletest";
import Resetpassword from "./pages/Resetpassword";

const AuthenticatedApp = () => {
  const { isLoadingAuth, isLoadingPublicSettings, authError, navigateToLogin } = useAuth();

  if (isLoadingPublicSettings || isLoadingAuth) {
    return (
      <div style={{ position:"fixed", inset:0, display:"flex", alignItems:"center", justifyContent:"center" }}>
        <div style={{ width:32, height:32, border:"4px solid #e2e8f0", borderTopColor:"#2563eb", borderRadius:"50%", animation:"spin 0.7s linear infinite" }} />
      </div>
    );
  }

  if (authError) {
    if (authError.type === 'user_not_registered') return <UserNotRegisteredError />;
    if (authError.type === 'auth_required') { navigateToLogin(); return null; }
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/pipeline" element={<Pipeline />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/calls" element={<Calls />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/team" element={<Team />} />
        <Route path="/ai-agent" element={<AIAgent />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profiletest" element={<Profiletest />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <QueryClientProvider client={queryClientInstance}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/prequalify" element={<Prequalify />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/onboardingtest" element={<OnboardingTest />} />
            <Route path="/resetpassword" element={<Resetpassword />} />
            <Route path="/*" element={<AuthenticatedApp />} />
          </Routes>
        </Router>
        <Toaster />
      </QueryClientProvider>
    </AuthProvider>
  )
}

export default App